import { Component, Inject, OnDestroy } from "@angular/core";
import { FormControl } from "@angular/forms";
import { MAT_DIALOG_DATA } from "@angular/material/dialog";
import { Subject } from "rxjs";
import { debounceTime, takeUntil } from "rxjs/operators";
import { ItemService } from "../services";

@Component({
    template: `
    <div mat-dialog-title style="margin-bottom: 0px;">
        <h4 style="margin-top: 0px; margin-bottom: 5px;">Top Tags from results</h4>
        <h6 style="margin: 0px;">Select tags to refine results</h6>
        <div style="font-size: 12px;">
            <mat-form-field fxFlex="40">
                <input matInput
                        #searchControlRef 
                        placeholder="Filter Tags" 
                        [formControl]="filterControl"/>
            </mat-form-field>
        </div>
    </div>
    <div mat-dialog-content style="height: calc(100vh - 100px); width: 650px;">
        <span *ngFor="let type of filteredTagSets">
            <h4 style="margin-bottom: 2px; margin-top: 15px; font-weight: bold;">{{tagDefs[type.key].label}}</h4>
            <button mat-button *ngFor="let tag of type.tagText.buckets"
                    (click)="toggleTag(tag)"
                    [ngClass]="tagDefs[type.key].cls"
                    [matTooltip]="(tagSelected(tag) ? 'Unselect ' : 'Select ') + cleanKey(tag.key)">
                <div style="display: inline-block;" *ngIf="!tagSelected(tag)">{{cleanKey(tag.key)}} ({{tag.doc_count }})</div>
                <div style="display: inline-block; font-weight: bold;" *ngIf="tagSelected(tag)">{{cleanKey(tag.key)}} ({{tag.doc_count }})</div>
                <div style="display: inline-block;">
                    <mat-icon *ngIf="tagSelected(tag)" style="padding-left: 5px; font-size: 15px; font-weight: bold; width: 20px;">done</mat-icon>
                </div>
            </button>
        </span>
    </div>
    <div mat-dialog-actions>
        <button mat-raised-button 
                    color="primary" 
                    [disabled]="!selectedTags.length" 
                    [mat-dialog-close]="selectedTags">Select</button>
        <button mat-button mat-dialog-close>Cancel</button>
    </div>
`})
export class TagSelectorDialogComponent implements OnDestroy {
    cleanupTime = new Subject<void>();
    availableTagSets: Attensa.TagSet[];
    filteredTagSets: Attensa.TagSet[];
    selectedTags: Attensa.TagSetTag[] = [];
    tagDefs: any;
    filterControl = new FormControl();

    constructor(@Inject(MAT_DIALOG_DATA) data: { initiallySelected: Attensa.TagSetTag[], availableTagSets: Attensa.TagSet[] }, itemService: ItemService) {
        this.tagDefs = itemService.tagDefs;
        this.availableTagSets = data.availableTagSets;
        data.initiallySelected.forEach(tag => {
            const set = this.availableTagSets.find(tagSet => tagSet.key === tag.type);
            const tst = set?.tagText?.buckets?.find(tst => tst.key === tag.key);
            if (tst) {
                this.selectedTags.push(tst);
            }
        });

        this.filterControl.valueChanges.pipe(debounceTime(500), takeUntil(this.cleanupTime))
        .subscribe(filterTerm => this.filterTagSets(filterTerm));

        this.filterTagSets(undefined);
    }

    filterTagSets(filterTerm: string) {
        const cleanTerm = filterTerm?.trim().toLowerCase();
        const filteredTagSets = JSON.parse(JSON.stringify(this.availableTagSets));
        if (cleanTerm?.length){
            filteredTagSets.forEach(ts => ts.tagText.buckets = ts.tagText.buckets.filter(tag => tag.key.toLowerCase().includes(cleanTerm)));
        }
        this.filteredTagSets = filteredTagSets;
    }

    toggleTag(tag): void {
        if (this.selectedTags.includes(tag)) {
            this.selectedTags.splice(this.selectedTags.indexOf(tag), 1);
        } else {
            this.selectedTags.push(tag);
        }
    }

    tagSelected(tag: Attensa.TagSetTag): boolean {
        return !!this.selectedTags.find(t => tag.key === t.key && tag.type === t.type); 
    }

    cleanKey(key: string): string {
        return key.replace(/_/g, ' ');
    }

    ngOnDestroy(): void {
        this.cleanupTime.next();
        this.cleanupTime.complete();
    }
}
